<script lang="ts">
    import { getContext } from 'svelte';
    import { Translate } from '../types';
    import InputField from './InputField.svelte';

    const translate = getContext<Translate>('translate');

    export let code = '';
    export let errors: string | undefined = undefined;

    function setValue(value: string) {
        code = value;
        validate();
    }

    function validate() {
        // Rules for the code
        // - 10 characters in total
        // - Alphanumeric (A–Z, 0–9)
        // - Structure: MGM + 7 alphanumeric characters
        // - Example: MGMSZJNL5G

        if (code.length > 0 && code.length !== 10) {
            errors = translate('referralCodeSection:errorLength');
        } else if (code.length > 0 && !/^MGM[A-Z0-9]{7}$/.test(code)) {
            errors = translate('referralCodeSection:errorFormat');
        } else {
            errors = undefined;
        }
    }
</script>

<section>
    <h2 class="base-headline">{translate('referralCodeSection:header')}</h2>
    <p>{@html translate('referralCodeSection:text')}</p>

    <InputField
        style="max-width: 300px;"
        label={translate('referralCodeSection:label')}
        maxLength={50}
        bind:value={code}
        {errors}
        id="referralCode"
        input={{ type: 'text', name: 'referralCode' }}
        on:change={(e) => setValue(e.target.value)} />
</section>

<style lang="scss" scoped>
    section {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
</style>
